<template>
  <div class="bgBlue">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="1"></HeaderNav>
    <Banner :banner="bannerList" @click="loseFocus()"></Banner>
    <div class="pro_box container">
      <ul>
        <li>
          <a @click="toDetail(1)">
            <i>锁水紧致</i>
            <div class="li_img"><img src="static/picture/1-22022411225qr.png" /></div>
            <div class="li_text">
              <p>
                面霜
                <em>CREAM</em>
              </p>
              <span>深润锁水 强韧修护</span>
            </div>
          </a>
        </li>
        <li>
          <a @click="toDetail(2)">
            <i>净颜不伤肤</i>
            <div class="li_img"><img src="static/picture/1-220224112133326.png" /></div>
            <div class="li_text">
              <p>
                洁面乳
                <em>CLEANSING FOAM</em>
              </p>
              <span>温和洁净 柔润呵护</span>
            </div>
          </a>
        </li>
        <li>
          <a @click="toDetail(3)">
            <i>抗氧抗老</i>
            <div class="li_img"><img src="static/picture/1-220224111tx63.png" /></div>
            <div class="li_text">
              <p>
                美容液
                <em>ESSENCE</em>
              </p>
              <span>滢润焕活 抗氧平衡</span>
            </div>
          </a>
        </li>
        <li>
          <a @click="toDetail(4)">
            <i>水油双补</i>
            <div class="li_img"><img src="static/picture/1-220224111i0942.png" /></div>
            <div class="li_text">
              <p>
                乳液
                <em>EMULSION</em>
              </p>
              <span>轻盈润泽 滋养强韧</span>
            </div>
          </a>
        </li>
        <li>
          <a @click="toDetail(5)">
            <i>水润清爽</i>
            <div class="li_img"><img src="static/picture/1-220224111152615.png" /></div>
            <div class="li_text">
              <p>
                化妆水
                <em>LOTION</em>
              </p>
              <span>水漾沁润 舒缓平衡</span>
            </div>
          </a>
        </li>
        <li>
          <a @click="toDetail(6)">
            <i>一瓶多效</i>
            <div class="li_img"><img src="static/picture/1-211130141515n0.png" /></div>
            <div class="li_text">
              <p>
                保湿凝胶霜
                <em>MOIST GEL</em>
              </p>
              <span>舒爽清滢 弹润赋活</span>
            </div>
          </a>
        </li>
        <li>
          <a @click="toDetail(7)">
            <i>养出芭蕾颈</i>
            <div class="li_img"><img src="static/picture/1-211130142ub29.png" /></div>
            <div class="li_text">
              <p>
                颈霜
                <em>NECK CREAM</em>
              </p>
              <span>平纹滋养 紧致轮廓</span>
            </div>
          </a>
        </li>
        <li>
          <a @click="toDetail(8)">
            <i>膜法时光</i>
            <div class="li_img"><img src="static/picture/1-21113014320t44.png" /></div>
            <div class="li_text">
              <p>
                面膜
                <em>SHEET MASK</em>
              </p>
              <span>水光滢润 匀亮肤色</span>
            </div>
          </a>
        </li>
        <li>
          <a @click="toDetail(9)">
            <i>补水式卸妆</i>
            <div class="li_img"><img src="static/picture/1-21113014351m95.png" /></div>
            <div class="li_text">
              <p>
                卸妆凝胶
                <em>CLEANSING GEL</em>
              </p>
              <span>深澈净透 澄净亮肤</span>
            </div>
          </a>
        </li>
        <li>
          <a @click="toDetail(10)">
            <i>抚纹小熨斗</i>
            <div class="li_img"><img src="static/picture/1-211130143p2w1.png" /></div>
            <div class="li_text">
              <p>
                浓缩精粹眼霜
                <em>CONCENTRATE EYE CREAM</em>
              </p>
              <span>水润明眸 丝滑水润</span>
            </div>
          </a>
        </li>
      </ul>
    </div>

    <hr class="hr_1 mb80" />
    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../../components/HeaderNav';
import FooterNav from '../../components/FooterNav';
import Banner from '../../components/Banner.vue';
import RightNav from '../../components/RightNav.vue';
import { apiGetDetail, apiChangeOther, apiAddNotes } from '../../api/job.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    Banner: Banner,
    RightNav: RightNav
  },
  data() {
    return {
      advertInfo: { image: '../../static/pC/ad.png' },
      id: '',
      login: false, //是否登录
      userInfo: [], //是否登录--用户信息
      bannerList: [{ url: 'static/picture/folktale_banner1.jpg' }, { url: 'static/picture/folktale_banner2.jpg' }, { url: 'static/picture/folktale_banner3.jpg' }]
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.judgeLogin();
  },
  methods: {
    toDetail(id) {
      this.$router.push({ path: '/jobIndex', query: { id: id } });
    },
    //跳转到外部链接
    linkOut(url) {
      if (url.includes('https://') || url.includes('http://')) {
        window.location.href = url;
      } else {
        window.location.href = `https://${url}`;
      }
    },

    //判断是否登录
    judgeLogin() {
      if (sessionStorage.getItem('login') != null && sessionStorage.getItem('login') != '') {
        this.login = sessionStorage.getItem('login');
        if (sessionStorage.getItem('userInfo') != null && sessionStorage.getItem('userInfo') != '') {
          var userInfo = sessionStorage.getItem('userInfo');
          this.userInfo = JSON.parse(userInfo);
        }
      }
    }
  }
};
</script>
<style scoped>
/*------------luara.html  start----------------*/
.classify_box {
  width: 100%;
  height: 116px;
  overflow: hidden;
  background: #fafafa;
}
.classify_box p {
  margin-top: 12px;
  text-align: right;
  padding-right: 60px;
  font-size: 12px;
  color: #000000;
  font-family: Font_Light;
}
.classify_box select {
  width: 198px;
  padding: 0 15px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #000;
  background: none;
  float: right;
  margin: 12px 30px 0 0;
  font-size: 14px;
  color: #000000;
  font-family: Font_Light;
}

.pro_box {
  overflow: hidden;
}
.pro_box li {
  width: 30%;
  margin: 0 5% 8% 0;
  float: left;
  text-align: center;
  overflow: hidden;
  position: relative;
}
.pro_box li:nth-child(3n) {
  margin: 0 0 8% 0;
}
.pro_box li a {
  color: #000;
}
.pro_box li a:hover {
  color: #000;
}
.pro_box li i {
  display: block;
  width: 80px;
  text-align: center;
  height: 20px;
  line-height: 20px;
  letter-spacing: 1px;
  font-style: normal;
  font-size: 13px;
  font-family: Font_Regular;
  border: 1px solid #000;
  z-index: 2;
  margin: 40px auto 0;
}
.pro_box li .li_img {
  width: 100%;
  overflow: hidden;
  padding-top: 135%;
  position: relative;
}
.pro_box li .li_img img {
  max-width: 100%;
  max-height: 100%;
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.pro_box li .li_text {
  text-align: center;
}
.pro_box li .li_text p {
  letter-spacing: 2px;
  font-size: 15px;
  font-family: Font_Medium;
  margin: 0 0 10px 0;
}
.pro_box li .li_text p em {
  letter-spacing: 1px;
  display: block;
  font-style: normal;
}
.pro_box li .li_text span {
  display: inline-block;
  padding: 0 16px;
  text-align: center;
  letter-spacing: 2px;
  height: 34px;
  line-height: 34px;
  color: #fff;
  background: #000;
  font-size: 15px;
  font-family: Font_Normal;
}
/*------------luara.html  end----------------*/
</style>



// WEBPACK FOOTER //
// src/view/Html/HOCTIME.vue